import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { CategoriesSelect } from "@/components/General/Faq/components/categories/categoriesSelect";
import { useFaqContext } from "@/components/General/Faq/context/faq.context";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Categories = ({ className, children }: Props) => {
    const { categories } = useFaqContext();

    return (
        <div className={cn("tw:pt-4 tw:mt-1", "tw:md:min-w-1/4", className)}>
            <div
                className={cn(
                    "tw:flex-col tw:items-start",
                    "tw:hidden",
                    "tw:md:flex"
                )}
            >
                <Mapped array={categories}>{children}</Mapped>
            </div>
            <CategoriesSelect className={cn("tw:block", "tw:md:hidden")} />
        </div>
    );
};
